import { createFileRoute } from '@tanstack/react-router';
import { TwContainer } from '~/lib/TwContainer';
import { Card, Divider, Text, Title } from '@mantine/core';
import BenifitsOfUs from '~/components/BenifitsOfUs';
import { SectionFive } from '~/components/home-sections/SectionFive';
import { SectionSix } from '~/components/home-sections/SectionSix';
import { useMediaQuery } from '@mantine/hooks';

export const Route = createFileRoute('/about/')({
	component: RouteComponent,
});

function RouteComponent() {
	const isMobile = useMediaQuery('(max-width: 600px)');
	return (
		<>
			<section
				className="bg-dark relative"
				style={{ transition: 'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s' }}>
				<div className="background-overlay"></div>
				<TwContainer className="py-24 px-8 z-10 relative">
					<Title className="text-6xl font-medium font-saira text-primary capitalize text-center">we are champtek</Title>
					<Title className="text-3xl font-semibold font-beVietnamPro text-white text-center">
						Our mission is to make your business <br />
						better through our solutions
					</Title>
					<Card className={'bg-secondary my-16'}>
						<div className={'flex md:flex-row flex-col md:p-16 justify-around'}>
							<Title className={'my-auto font-saira text-gray-300 md:text-5xl text-2xl max-w-sm md:text-right'}>
								Delivering IT Solutions that enable you to work smarter
							</Title>
							<div>
								<Divider
									orientation={isMobile ? 'vertical' : 'horizontal'}
									className={'md:h-full w-full md:w-0 h-0 border-primary border-2 mx-0'}
								/>
							</div>
							<Text className={'text-gray-200 text-base my-auto flex-grow max-w-sm'}>
								champtek is a provider of software development and testing services. Having talented software engineers on board, we craft compelling
								web, desktop, and mobile applications for our clients.
								<br />
								<br />
								Since our inception, we have partnered with numerous companies and delivered operational gains to startup, emerging, and established
								organizations in the United States.
							</Text>
						</div>
					</Card>
				</TwContainer>
			</section>
			<BenifitsOfUs />
			<SectionFive />;
			<SectionSix />
		</>
	);
}
